import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(15 34)">
      <g stroke="#51565c">
        <path d="m19 0h82v82h-82z" strokeWidth="3.2" />
        <g transform="translate(67.235294 28.941176)">
          <path
            d="m25.2974234 11.8172494-9.2978079-10.33532059 1.6458829-1.48192881 9.9643904 11.076285c.3789507.4212366.3789507 1.0606922 0 1.4819288l-9.9643904 11.076285-1.6458829-1.4819288z"
            fill="#51565c"
            fillRule="nonzero"
            strokeWidth=".8"
            transform="matrix(1 0 0 -1 0 23.634498)"
          />
          <path
            d="m0 12.0588235h23.7299822"
            strokeDasharray=".8"
            strokeLinecap="square"
            strokeWidth="3.2"
            transform="matrix(-1 0 0 1 24.275278 0)"
          />
        </g>
        <g transform="matrix(-1 0 0 1 52.764705 28.941176)">
          <path
            d="m25.2974234 11.8172494-9.2978079-10.33532059 1.6458829-1.48192881 9.9643904 11.076285c.3789507.4212366.3789507 1.0606922 0 1.4819288l-9.9643904 11.076285-1.6458829-1.4819288z"
            fill="#51565c"
            fillRule="nonzero"
            strokeWidth=".8"
            transform="matrix(1 0 0 -1 0 23.634498)"
          />
          <path
            d="m0 12.0588235h23.7299822"
            strokeDasharray=".8"
            strokeLinecap="square"
            strokeWidth="3.2"
            transform="matrix(-1 0 0 1 24.275278 0)"
          />
        </g>
      </g>
      <g stroke="#fff" strokeWidth="2">
        <path d="m97 47h14v14h-14z" fill="#53a2d9" />
        <path d="m93 20h14v14h-14z" fill="#7bb835" />
        <path d="m107 32h14v14h-14z" fill="#15539f" />
      </g>
      <g stroke="#fff" strokeWidth="2">
        <path d="m8 21h14v14h-14z" fill="#53a2d9" />
        <path d="m13 48h14v14h-14z" fill="#15539f" />
        <path d="m-1 36h14v14h-14z" fill="#7bb835" />
      </g>
    </g>
  </Svg>
)
